import { Children, useState, useEffect, type ReactNode, type ReactElement } from 'react';

interface PanelGridProps { children: ReactNode; }

function useIsMobile(breakpoint = 768): boolean {
  const [isMobile, setIsMobile] = useState(
    () => typeof window !== 'undefined' && window.innerWidth < breakpoint
  );

  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${breakpoint - 1}px)`);
    const handler = (e: MediaQueryListEvent) => setIsMobile(e.matches);
    setIsMobile(mq.matches);
    mq.addEventListener('change', handler);
    return () => mq.removeEventListener('change', handler);
  }, [breakpoint]);

  return isMobile;
}

export function PanelGrid({ children }: PanelGridProps) {
  const isMobile = useIsMobile();

  const sorted = isMobile
    ? Children.toArray(children).sort((a, b) => {
        const pa = (a as ReactElement)?.props?.mobilePriority ?? 99;
        const pb = (b as ReactElement)?.props?.mobilePriority ?? 99;
        return pa - pb;
      })
    : children;

  return (
    <div data-testid="ops-panel-grid" className="grid gap-4 p-4 grid-cols-1 md:grid-cols-[repeat(auto-fit,minmax(360px,1fr))] lg:grid-cols-[repeat(auto-fit,minmax(400px,1fr))]">
      {sorted}
    </div>
  );
}
